<template>
    <div :class="classes">
        <Tag :color="tagColor" @click="$emit('click')">
            {{ statusText }}
        </Tag>
    </div>
</template>

<script lang="ts">
import { BannerQaStatus, BannerQaStatusLabel } from "@/enums/banners";
import type { PropType } from "vue";

export default {
    props: {
        display: {
            type: String as PropType<"block" | "inline-block">,
            default: "inline-block",
            validator(value) {
                return ["block", "inline-block"].includes(value as "block" | "inline-block");
            }
        },
        isClickable: {
            default: false,
            type: Boolean
        },
        status: {
            type: String as PropType<(typeof BannerQaStatus)[keyof typeof BannerQaStatus]>,
            default: BannerQaStatus.Draft,
            validator(value: string) {
                return Object.values(BannerQaStatus).includes(
                    value as (typeof BannerQaStatus)[keyof typeof BannerQaStatus]
                );
            }
        }
    },
    emits: ["click"],
    computed: {
        classes() {
            const classes = ["qa-status-label"];

            if (this.display === "block") {
                classes.push("qa-status-label--display-block");
            }

            if (!this.isClickable) {
                classes.push("qa-status-label--pointer-events-none");
            }

            return classes;
        },
        statusText() {
            return BannerQaStatusLabel[this.status];
        },
        tagColor() {
            switch (this.status) {
                case BannerQaStatus.Approved: {
                    return "success";
                }
                case BannerQaStatus.InReview: {
                    return "warning";
                }
                case BannerQaStatus.Rejected: {
                    return "error";
                }
                default:
                    return "default";
            }
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.qa-status-label {
    display: inline-block;
}

.qa-status-label--display-block {
    display: block;

    .ivu-tag {
        text-align: center;
        width: 100%;
        cursor: pointer;
    }
}

.qa-status-label--pointer-events-none {
    pointer-events: none;
}
</style>
